function isEnableElement(element) {
  return !element.hasAttribute("disabled") && !element.hasAttribute("aria-disabled");
}
function findMatchedItemIndex(params) {
  const { getListRef, filter: filterFn } = params;
  return getListRef().reduce((accm, curr, index) => {
    if (filterFn(curr) && curr.ref.current !== null && isEnableElement(curr.ref.current)) {
      accm.push(index);
    }
    return accm;
  }, []);
}
function getClickableAttribute() {
  return {
    "data-type": "clickable"
  };
}
function isClickableElement(target) {
  if (!target || target === document.body) {
    return false;
  }
  const { tagName, onclick, parentElement, dataset } = target;
  const isClickable = tagName === "A" || typeof onclick === "function" && tagName === "BUTTON" || dataset.type === "clickable" && typeof onclick === "function";
  if (isClickable) {
    return true;
  }
  return isClickableElement(parentElement);
}

export { findMatchedItemIndex, getClickableAttribute, isClickableElement, isEnableElement };
//# sourceMappingURL=element.mjs.map
